import { offlineDb } from './db'

// Note: client temp ids for optimistic rows. They must be negative (to tell them apart from real
// server ids) AND fit in a signed 32-bit int, because the server's id fields (loadingId,
// diggingPatternId, geoRehandleId) are int. Previously we used -(Date.now()), which is ~-1.78e12
// and overflows int - a single such id made the whole /Sync request fail validation with a 400,
// stranding the entire queue. Instead we hand out a decrementing counter seeded just below any
// temp id already sitting in the queue, so ids stay small, unique, and collision-free across reloads.
let nextId: number | null = null

// Note: the counter is seeded from the queue, so one oversized id already sitting there would drag
// every id handed out afterwards out of int range too. Ignore anything below this when seeding.
const SAFE_FLOOR = -2_000_000_000

export async function nextTempId(): Promise<number> {
  if (nextId === null) {
    const items = await offlineDb.mutationQueue.toArray()
    let min = 0
    for (const item of items) {
      if (typeof item.entityId === 'number' && item.entityId < min && item.entityId > SAFE_FLOOR) {
        min = item.entityId
      }
    }
    nextId = min
  }
  nextId -= 1
  return nextId
}
